import { accessRole } from "../../../../../../helpers/access_role"
import { config } from "../../../../../../helpers/config_global"
import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import { Tooltip } from "reactstrap"
import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'
import { cancelToken } from "../../../../../../services/adapters/master/penialian360Service"
import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../../services/apiResponse'
import moment from "moment"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source;
    historyTable = 'historyPenilaian360KompetensiActive';
    defaultOrder = 'ms360_competence_id';
    defaultSize = 10;
    defaultSort = 'asc';
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        };
    }

    loadData = async () => {
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter));

        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size;
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({ defaultSize: this.state.filter.page_size });
            offset = 0;
            this.configDatatable.page_number = 1;
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        };
        await this.dataTableBloc.fetchRowTable(query, this.source.token);
    }

    setTokenAPI = () => {
        if (typeof this.source !== typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken();
        this.loadData();
    }

    confirmResponse = (response) => {
        let forState = {};
        switch (response) {
            case 'cancel':
                forState = { confirm: false };
                break;
            case 'confirm':
                forState = { loading: true, confirm: false };
                this.inactiveData();
                break;
            case 'success':
                forState = { success: false, redirect: true };
                break;
            case 'failed':
                forState = { failed: false };
                break;
            default:
        }
        this.setState(forState);
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
    }

    componentDidMount() {
        this.setTokenAPI();

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({ loadingTable: false });
                    break;
                case apiResponse.LOADING:
                    this.setState({ loadingTable: true });
                    break;
                case apiResponse.COMPLETED:
                    const response = result.data.response;
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    });
                    break;
                case apiResponse.ERROR:
                    this.setState({ loadingTable: false });
                    break;
                default:
                    break;
            }
        });

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI();
                        if (this.props.handleInactiveSuccess) {
                            this.props.handleInactiveSuccess();
                        }
                    });
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true
                    });
                    break;
                default:
                    break;
            }
        });
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe();
        this.dataTableBloc.inactiveChannel.unsubscribe();
    }

    columns = [
        {
            key: "ms360_question_type_name",
            text: "Bagian Soal",
            className: "rating",
            sortable: true
        },
        {
            key: "ms360_competence_name",
            text: "Nama Kompetensi",
            className: "address",
            sortable: true,
            width: '35%'
        },
        {
            key: "ms360_competence_description",
            text: "Deskripsi",
            className: "rating",
            sortable: true,
            cell: record => record.ms360_competence_description || '-'
        },
        {
            key: "ms360_competence_created",
            text: "Tanggal",
            className: "rating",
            sortable: true,
            width: '130px',
            cell: record => {
                return (record.ms360_competence_created != null) ? moment(record.ms360_competence_created).format('DD/MM/YYYY') : '-';
            }
        },
        {
            key: "action",
            text: "Aksi",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.ms360_competence_uuid;
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-k-" + thisId}
                                onClick={() => {
                                    this.setState({ detailUuid: record.ms360_competence_uuid });
                                }}
                                style={{ marginRight: '2px', padding: '2px 5px' }}>
                                <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                placement="top"
                                isOpen={this.state["detail-k-" + thisId]}
                                target={"detail-k-" + thisId}
                                toggle={() => {
                                    this.setState({ ["detail-k-" + thisId]: !this.state["detail-k-" + thisId] });
                                }}>
                                Detail
                            </Tooltip>
                        </span>
                        {accessRole('update') ?
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-k-" + thisId}
                                    onClick={() => {
                                        this.setState({ updateUuid: record.ms360_competence_uuid });
                                    }}
                                    style={{ marginRight: '2px', padding: '2px 5px' }}>
                                    <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    placement="top"
                                    isOpen={this.state["update-k-" + thisId]}
                                    target={"update-k-" + thisId}
                                    toggle={() => {
                                        this.setState({ ["update-k-" + thisId]: !this.state["update-k-" + thisId] });
                                    }}>
                                    Perbaharui
                                </Tooltip>
                            </span>
                            : null
                        }
                        {accessRole('delete') ?
                            <span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"delete-k-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            inactiveUuid: record.ms360_competence_uuid,
                                            confirm: true
                                        });
                                    }}
                                    style={{ padding: '2px 5px' }}>
                                    <i className="uil-trash-alt"></i>
                                </button>
                                <Tooltip
                                    placement="top"
                                    isOpen={this.state["delete-k-" + thisId]}
                                    target={"delete-k-" + thisId}
                                    toggle={() => {
                                        this.setState({ ["delete-k-" + thisId]: !this.state["delete-k-" + thisId] });
                                    }}>
                                    Nonaktifkan
                                </Tooltip>
                            </span>
                            : null
                        }
                    </Fragment>
                );
            }
        }
    ];

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={800}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI();
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menonaktifkan data Kompetensi ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil dinonaktifkan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal dinonaktifkan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
                {this.state.detailUuid !== null ?
                    <Redirect to={`${window.location.pathname}?detail&uuid=` + this.state.detailUuid} />
                    : null}
                {this.state.updateUuid !== null ?
                    <Redirect to={`${window.location.pathname}?update&uuid=` + this.state.updateUuid} />
                    : null}
            </>
        );
    }
}

export default TableActiveComponent
